import { useTranslation } from 'react-i18next'

import { NUM_CATEGORIES } from '@mc/constants'
import Experiment from '@mc/experiments-react'
import { getNumberOfInstructors } from '@mc/instructors'

import { HP_SUBHEADER_COPY_EXPERIMENT_NAME } from './constants'
import { HP_SUBHEADER_COPY_I18N_NAMESPACE } from './i18n'

interface HpSubheaderCopyExpProps {
  control: React.ReactNode
}

export const HpSubheaderCopyExp = ({ control }: HpSubheaderCopyExpProps) => {
  const { t } = useTranslation(HP_SUBHEADER_COPY_I18N_NAMESPACE)

  return (
    <Experiment
      name={HP_SUBHEADER_COPY_EXPERIMENT_NAME}
      default={() => control}
      variant_1={() =>
        t('home.hero.subtitle', {
          instructors: getNumberOfInstructors(),
          categories: NUM_CATEGORIES,
        })
      }
    />
  )
}
